import { Language } from "../../App";
import { useNavigate, useParams } from "react-router-dom";
import { useContext, useState ,useLayoutEffect} from "react";
import { Col, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";


const tabIdToValue = {
  1: "all",
  2: "my-events",
  3: "joined-events",
  4: "saved-events",
};

export default function EventTabs({ activeTab, setActiveTab, setSelectedEvent }) {
  
  const { id } = useParams();
  const navigate = useNavigate();
  const { lang } = useContext(Language);
const tabsArray = [
  { id: 1, title: lang.see_all, value: "all" },
  { id: 2, title: "My Events", value: "my-events" },
  { id: 3, title: "Joined Events", value: "joined-events" },
  { id: 4, title: "Saved Events", value: "saved-events" },
];
  useLayoutEffect(() => {
    const tabValue = tabIdToValue[id];
    if (tabValue) setActiveTab(tabValue);
  }, [id, setActiveTab]);

  return (
    <div className="w-100 d-flex align-items-start _margin-top-2 justify-content-between">
      <div className="d-flex margin-top-2 align-items-center scroll-hide gap-3" style={{    overflow: "auto",
    whiteSpace: "nowrap"}}>
        {tabsArray.map((tab) => (
          <button
            key={tab.id}
            className={`btn btn-sm bg-white fw-bold roboto-medium shadow-sm rounded text-gray ${
              activeTab === tab.value ? "text-dark" : ""
            }`}
            onClick={() => {
              setActiveTab(tab.value);
              navigate(`/events/${tab.id}`);
              setSelectedEvent(null);
            }}
          >
            {lang[tab.value.replace("-", "_")] || tab.title}
          </button>
        ))}
      </div>
    </div>
  );
}



export const FilterModal = ({ filterModal, setFilterModal }) => {
  const { lang } = useContext(Language);
  const [filterData, setFilterData] = useState({ location: "", distance: 25.0 });

  const resetFilters = () => setFilterData({ location: "", distance: 25.0 });

  return (
    <Modal isOpen={filterModal} centered>
      <ModalHeader>{lang?.filters}</ModalHeader>
      <ModalBody>
        <Row className="mb-3">
          <Col>
            <div className="d-flex justify-content-between">
              <label className="pb-1 fs-15 roboto-medium">{lang?.location}</label>
              <small className="fw-bold text-blue cursor" onClick={resetFilters}>
                {lang?.reset}
              </small>
            </div>
            <div className="position-relative">
              <input
                type="text"
                className="py-2 form-control"
                placeholder="City, Country"
                value={filterData.location}
                onChange={(e) => setFilterData((prev) => ({ ...prev, location: e.target.value }))}
              />
            </div>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <div className="d-flex justify-content-between">
              <label className="pb-1 fs-15 roboto-medium">{lang?.distance}</label>
              <label className="pb-1 fs-15 roboto-medium">
                {filterData.distance} {lang?.km}
              </label>
            </div>
            <Input
              type="range"
              value={filterData.distance}
              onChange={(e) =>
                setFilterData((prev) => ({ ...prev, distance: parseFloat(e.target.value) }))
              }
              min={0}
              max={100}
            />
            <div className="d-flex justify-content-between">
              <label className="pb-1 fs-15 roboto-medium">0 {lang?.km}</label>
              <label className="pb-1 fs-15 roboto-medium">100 {lang?.km}</label>
            </div>
          </Col>
        </Row>
      </ModalBody>

      <ModalFooter>
        <div className="justify-content-end gap-3 d-flex mt-3 w-100">
          <button
            className="manue-hover text-dark border-1 border rounded w-100 py-2 fs-md-14"
            onClick={() => setFilterModal(false)}
          >
            {lang?.cancel}
          </button>
          <button
            className="border-0 py-2 fs-md-14 rounded w-100 btn-blue"
            onClick={() => setFilterModal(false)}
          >
            {lang?.apply_filter}
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

